import { useEffect, useMemo, useState } from "react";
import {
  getBackgroundUploadQueueEventName,
  getBackgroundUploadQueueSnapshot,
  type BackgroundUploadJob,
} from "@/lib/background-upload-queue";

export function useBackgroundUploadQueue() {
  const [jobs, setJobs] = useState<BackgroundUploadJob[]>([]);

  useEffect(() => {
    let cancelled = false;

    const refresh = async () => {
      const snapshot = await getBackgroundUploadQueueSnapshot();
      if (!cancelled) {
        setJobs(snapshot);
      }
    };

    const handleQueueUpdate = (event: Event) => {
      const detail = (event as CustomEvent<{ jobs?: BackgroundUploadJob[] }>).detail;
      if (detail?.jobs) {
        setJobs(detail.jobs);
        return;
      }
      void refresh();
    };

    void refresh();
    window.addEventListener(getBackgroundUploadQueueEventName(), handleQueueUpdate);
    return () => {
      cancelled = true;
      window.removeEventListener(getBackgroundUploadQueueEventName(), handleQueueUpdate);
    };
  }, []);

  const activeJob = useMemo(
    () => jobs.find((job) => job.status === "processing") ?? jobs[0] ?? null,
    [jobs],
  );

  return {
    jobs,
    activeJob,
    pendingCount: jobs.length,
  };
}
